import React, { forwardRef }    from 'react';
import PropTypes                from 'prop-types';

import ResultsBG                from '../../../../../assets/images/results.png';
import ArrowIcon                from '../../../../../assets/images/arrow_icon.jpg';

import styles                   from './ResultsBlock.styl';

function ResultsBlock(props, ref) {
    // const {  } = props;

    // const {} = useMessage();

    return  (
        <section
            className = {styles.ResultsBlock}
            ref       = {ref}
        >
            <div className={styles.leftBlock}>
                <div className={styles.blockName}>
                    <span className={styles.dot} />
                    Potential Results
                </div>
                <h2 className={styles.blockTitle}>
                    {'It\'s time to unlock some awesome potential'}
                </h2>
                <h3 className={styles.description}>
                    Our platform simplifies complex data and gives you a unified view of campaign performance so you can make better, faster marketing choices.
                </h3>
                <div className={styles.results}>
                    <div className={styles.result}>
                        <div className={styles.resultTitle}>
                            ROAS Boost
                        </div>
                        <div className={styles.resultValue}>
                            <img src={ArrowIcon} className={styles.arrowIcon} />
                            30%
                        </div>
                    </div>
                    <div className={styles.result}>
                        <div className={styles.resultTitle}>
                            Revenue Increase
                        </div>
                        <div className={styles.resultValue}>
                            <img src={ArrowIcon} className={styles.arrowIcon} />
                            25%
                        </div>
                    </div>
                    <div className={styles.result}>
                        <div className={styles.resultTitle}>
                            Automations
                        </div>
                        <div className={styles.resultValue}>
                            <img
                                src       = {ArrowIcon}
                                className = {styles.arrowIcon}
                            />
                            90%
                        </div>
                    </div>
                    <div className={styles.result}>
                        <div className={styles.resultTitle}>
                            ROAS Variability
                        </div>
                        <div className={styles.resultValue}>
                            <img src={ArrowIcon} className={styles.arrowIcon} />
                            35%
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.rightBlock}>
                <img
                    src       = {ResultsBG}
                    className = {styles.blockImage}
                />
            </div>
        </section>
    );
}

ResultsBlock.propTypes = {
    className : PropTypes.string,
    message   : PropTypes.string
};

ResultsBlock.defaultProps = {
    className : '',
    message   : ''
};

export default forwardRef(ResultsBlock);
